import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import jwt_decode from 'jwt-decode';
import { parse } from 'query-string';
import { VbzAnimation } from '@smiles/voebiz-ui-kit';

const Callback: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [jwt, setJwt] = useState('');
  const params = useMemo(() => parse(location.search), [location]);
  const [animationState, setAnimationState] = useState({ isLoading: false, isSuccess: false });
  const [onFinishAnimation, setOnFinishAnimation] = useState<() => void>();
  const { t } = useTranslation('callback');

  const message = {
    error: [],
    loading: [t('one_moment')],
    success: [t('ready')],
  };

  const getToken = async () => {
    try {
      const token = await getAccessTokenSilently();
      localStorage.setItem('session-token', token);
      setJwt(token);
    } catch(e) {
      console.log('Error to get JWT: ', e);
      localStorage.removeItem('session-token');
      setJwt('error');
    }
  };

  const validateActions = (token: string) => {
    setOnFinishAnimation(() => {
      let redirectURL = '';

      const decoded: { sub: string; 'https://voebiz.api/legacy': string } = jwt_decode(token);
      if (decoded && decoded['https://voebiz.api/legacy'] === 'true') {
        const memberNumber = decoded.sub.substring(decoded.sub.lastIndexOf('|') + 1);
        redirectURL = `/validar/mensagem?id=legado&memberNumber=${memberNumber}`;
      } else if (params.ref) {
        redirectURL = params.ref as string;
      } else {
        redirectURL = `${window.location.origin}/home?upd=${new Date().getTime()}`;
      }

      window.location.href = redirectURL;
    });
    setAnimationState({ isLoading: false, isSuccess: true });
  };

  const errorJwt = () => {
    setOnFinishAnimation(() => {
      let location = '/validar/erro';
      if (params.error_description) {
        const description = params.error_description;
        if (description.indexOf('REGISTRATION IN ANALYSIS') >= 0) {
          location = '/validar/mensagem?id=em-analise';
        } else if (description.indexOf('code (2)') >= 0 || description.indexOf('code (3)') >= 0) {
          location = '/validar/mensagem?id=tentar-de-novo';
        }
      }
      window.location.href = location;
    });
    setAnimationState({ isLoading: false, isSuccess: false });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState({ isLoading: true, isSuccess: true });
    }, 1050);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (params.error) {
      setJwt('error');
    } else {
      getToken();
    }
  }, []);

  useEffect(() => {
    if (jwt) {
      if (jwt === 'error') {
        errorJwt();
      } else {
        validateActions(jwt);
      }
    }
  }, [jwt]);


  return <VbzAnimation currentState={animationState} onExit={onFinishAnimation} message={message} finishMode="yes" />;
};

export default Callback;
